Object.defineProperty(exports, "__esModule", { value: true });
exports.aesopDarkColorTokens = exports.aesopLightColorTokens = void 0;
var aesop_light_1 = require("./aesop-light");
Object.defineProperty(exports, "aesopLightColorTokens", { enumerable: true, get: function () { return aesop_light_1.aesopLightColorTokens; } });
var aesop_dark_1 = require("./aesop-dark");
Object.defineProperty(exports, "aesopDarkColorTokens", { enumerable: true, get: function () { return aesop_dark_1.aesopDarkColorTokens; } });
//# sourceMappingURL=index.js.map